<template>
    <div v-if="value">
        <div v-if="usage === 'info'">
            <div class="text-center mb-5"><alert-icon usage="info"/></div>
            <div class="text-center mb-3 error-state-bold" style="font-size: 20px;">No {{ type }}</div>
            <div class="text-center mb-3">This student does not have any available {{ type.toLowerCase() }} to link.</div>
        </div>
        <div v-else-if="usage === 'error'">
            <div class="text-center mb-5"><alert-icon usage="error"/></div>
            <div class="text-center mb-3 error-state-bold" style="font-size: 20px;">Unable to Load {{ type }}</div>
            <div class="text-center mb-3">Please try again later.</div>
        </div>
    </div>
</template>

<script>
    import AlertIcon from '@/components/common/AlertIcon'

    export default {
        name: 'ErrorState',

        components: {
            AlertIcon
        },

        props: {
            value: {
                type: Boolean, 
                default: false,
            },  
            type: {
                type: String,
                default: ''
            },
            usage: {
                type: String,
                default: 'info'
            },
        }
    }
</script>

<style lang="scss" scoped>
    .error-state-bold {
        font-family: 'HyperlegibleSans-Medium', Hyperlegible Sans, 'Roboto', sans-serif !important;
    }
</style>
